export * from "./ScorePanel";
export { default } from "./ScorePanel";
